import ClientDetail from "./ClientDetail"

export default  ClientDetail;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/index.js